import { render, staticRenderFns } from "./overlay-button.vue?vue&type=template&id=67869bd1"
import script from "./overlay-button.vue?vue&type=script&lang=js"
export * from "./overlay-button.vue?vue&type=script&lang=js"
import style0 from "./overlay-button.vue?vue&type=style&index=0&id=67869bd1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports